import type { CheckoutConfig } from '#types/config/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  allowSplitPayments: {
    EMEA: false,
    NORA: false
  }
} satisfies RecursivePartial<CheckoutConfig['payments']>
